<div [ngClass]="{'fullscreenEditor' : fullscreen && isForDialog}">
    <mat-toolbar class="ace-toolbar" [ngClass]="{'details-ace-toolbar' : !isForDialog}">
        <span class="spacer"></span>
        <button mat-icon-button (click)="toggleFullScreen()" aria-label="Fullscreen">
            <mat-icon *ngIf="!fullscreen">fullscreen</mat-icon> <mat-icon  *ngIf="fullscreen">close_fullscreen</mat-icon>
        </button>
    </mat-toolbar>
    <div #editor [ngClass]="{'code-editor' : isForDialog, 'details-code-editor' : !isForDialog}"></div>
</div>